__turbopack_context__.v({
  "searchSuggestionsContainer": "styles-module__3WWifG__searchSuggestionsContainer",
  "searchSuggestionsContainer--fullViewPort": "styles-module__3WWifG__searchSuggestionsContainer--fullViewPort",
  "searchSuggestionsContainer--variant": "styles-module__3WWifG__searchSuggestionsContainer--variant",
  "searchSuggestionsContainer--verticalPadding": "styles-module__3WWifG__searchSuggestionsContainer--verticalPadding",
  "suggestionClearButton": "styles-module__3WWifG__suggestionClearButton",
  "suggestionListHeader": "styles-module__3WWifG__suggestionListHeader",
  "suggestionTitle": "styles-module__3WWifG__suggestionTitle",
});
